<template>
    <div class="row panel-body">
        <form method="get" :action="'/quiz/correction/' + lessonId + '/country/' + country + '/language/' + language">
            <div class="col-md-5">
                <h4>Choose the Country</h4>
                <select id="country" v-model="country" class="form-control">
                    <option :value="null" selected disabled>- Choose -</option>
                    <option value="XX">Master (or Multiple Countries)</option>
                    <option v-for="currentCountry in countries"
                            :value="currentCountry.id"
                            v-text="currentCountry.title">
                    </option>
                </select>
            </div>

            <div class="col-md-5" v-if="country">
                <h4>Choose the Language</h4>
                <select class="form-control" v-model="language">
                    <option :value="null" selected disabled>- Choose -</option>
                    <option value="en">English (or Multiple Languages)</option>
                    <option v-for="currentLanguage in languages"
                            :value="currentLanguage.id"
                            v-text="currentLanguage.title">
                    </option>
                </select>
            </div>

            <div class="col-md-2" style="line-height: 90px;">
                <submit-button :disabled="!country || !language"></submit-button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: [
            'saveRoute',
            'questionsJson',
            'countriesJson',
            'languagesJson',
            'lessonId',
        ],

        data: function () {
            return {
                csrfToken: window.csrfToken,
                questions: JSON.parse(this.questionsJson),
                countries: JSON.parse(this.countriesJson),
                languages: JSON.parse(this.languagesJson),
                country: null,
                language: null,
            };
        },
    };
</script>
